import { FC, ReactNode } from 'react'

import clsx from 'clsx'

import { RadioButton } from 'shared/ui/radio-button'

import s from './styles.module.scss'

interface Props {
  icon: ReactNode
  title: string
  subTitle?: string
  isActive?: boolean
  onClick?: () => void
}

export const PaymentOption: FC<Props> = ({
  icon,
  title,
  subTitle,
  isActive,
  onClick,
}) => {
  return (
    <div
      className={clsx(s.container, isActive && s.active)}
      onClick={onClick}
    >
      {icon}

      <div className={s.text}>
        <p className={clsx(s.title, 'semi-bold-14')}>{title}</p>

        {subTitle && (
          <p className={clsx(s.subTitle, 'medium-12')}>{subTitle}</p>
        )}
      </div>

      <RadioButton
        readonly
        isActive={isActive}
      />
    </div>
  )
}
